
import Vue from 'vue'
import * as Api from '@/api/PartyIdentityUserApi'
import { PartyIdentityUserDto } from '@ViewModels/PartyIdentityUserDto'
import { Alert } from '@/components'
import { SaveButton } from '@/components/buttons'

export default Vue.extend({
   name: 'VerifyEmail',
   props: { schoolId: String, editingItem: Object as () => PartyIdentityUserDto },
   data() {
      return {
         processing: false,
         processed: false,
      }
   },
   computed: {
      confirmed(): boolean {
         return this.editingItem && this.editingItem.EmailConfirmed
      },
   },
   methods: {
      async action() {
         try {
            this.processing = true
            await Api.markUserEmailConfirmed(this.editingItem.Id)
            this.editingItem.EmailConfirmed = true
            this.processed = true
         } finally {
            this.processing = false
         }
      },
   },
   components: {
      Alert,
      SaveButton,
   },
})
